<!--=====================================
=            CHARTBARECHARTS            =
======================================-->
<template><div justify center >
  <div id="echartBar" style="height: 300px;max-width:600px"></div></div>
</template>
<script>
export default {
  mounted() {
    //CHARTS
    var _extends =
      Object.assign ||
      function(target) {
        for (var i = 1; i < arguments.length; i++) {
          var source = arguments[i];
          for (var key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
              target[key] = source[key];
            }
          }
        }
        return target;
      };
    // Chart in Dashboard version 1
    var echartElemBar = document.getElementById("echartBar");
    if (echartElemBar) {
      var echartBar = echarts.init(echartElemBar);
      echartBar.setOption({
        legend: {
          borderRadius: 0,
          orient: "horizontal",
          x: "right",
          data: ["Online", "Offline"]
        },
        grid: {
          left: "8px",
          right: "8px",
          bottom: "0",
          containLabel: true
        },
        tooltip: {
          show: true,
          backgroundColor: "rgba(0, 0, 0, .8)"
        },
        xAxis: [
          {
            type: "category",
            data: [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sept",
              "Oct",
              "Nov",
              "Dec"
            ],
            axisTick: {
              alignWithLabel: true
            },
            splitLine: {
              show: false
            },
            axisLine: {
              show: true
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            axisLabel: {
              formatter: "${value}"
            },
            min: 0,
            max: 100000,
            interval: 25000,
            axisLine: {
              show: false
            },
            splitLine: {
              show: true,
              interval: "auto"
            }
          }
        ],

        series: [
          {
            name: "Online",
            data: [
              35000,
              69000,
              22500,
              60000,
              50000,
              50000,
              30000,
              80000,
              70000,
              60000,
              20000,
              30005
            ],
            label: {
              show: false,
              color: "#845EC2"
            },
            type: "bar",
            barGap: 0,
            color: "#845EC2",
            smooth: true,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowOffsetY: -2,
                shadowColor: "rgba(0, 0, 0, 0.3)"
              }
            }
          },
          {
            name: "Offline",
            data: [
              45000,
              82000,
              35000,
              93000,
              71000,
              89000,
              49000,
              91000,
              80200,
              86000,
              35000,
              40050
            ],
            label: {
              show: false,
              color: "#A178DF"
            },
            type: "bar",
            color: "#A178DF",
            smooth: true,
            itemStyle: {
              emphasis: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowOffsetY: -2,
                shadowColor: "rgba(0, 0, 0, 0.3)"
              }
            }
          }
        ]
      });
      $(window).on("resize", function() {
        setTimeout(function() {
          echartBar.resize();
        }, 500);
      });
    }

    // Chart in Dashboard version 1
  }
};
</script>
<style scoped>
.chartjs-statistic {
  background: transparent;

  padding: 0 5px;
  border: 0;
  border-radius: 5px;
}

.chartjs-title {
  font-size: 16px;
}
</style>

<!--====  End of CHARTBARECHARTS  ====-->